import React, { useEffect, useRef, useState } from "react";
import { Hero3dCommerce } from '../../components';
import { Banner } from '../../components';
import { Loader } from '../../components';
import { ProdsCarousel } from '../../components';

import { VideoScrollAlone } from '../../components';
import { FormOverlay } from '../../components';
import { HomeColumns } from '../../components';
import { useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom';
import { useSelector } from "react-redux";
import {
  setLoader,
} from "../../redux/loader/loader.actions";
import { BaseUrl } from "../../config";

const Products3dCommerceContainer = (props) => {
  const [isFetching, setIsFetching] = useState(true)
  const [isMobile, setIsMobile] = useState(false)
  const [arrayImgsCarousel, setArrayImgsCarousel] = useState([])
  const [isOverlayOpen, setIsOverlayOpen] = useState(false)
  let autoOpen = false;
  const loader = useSelector((state) => state.loader);
  const numbers = useRef(null)
  const dispatch = useDispatch();
  let history = useHistory();
  
  const imgHero = require('../../assets/carousel-placeholder-2.jpg')

  let arrayLoad = [
    imgHero
  ]
  
  const openOverlay = () => {
    setIsOverlayOpen(!isOverlayOpen)
  }

  const clickLink = () => {
    dispatch(setLoader(true));
    setTimeout(() =>{ 
      document.body.scrollTop = 0;
      history.push('/3d-commerce-experience')
    }, 500);
  }

  // const srcIframeArray = [
  //   "https://sketchfab.com/models/086cb5d3ce504f11a085a3d5acb6c00b/embed?autospin=0.1&autostart=1&camera=0&transparent=1&ui_animations=0&ui_infos=0&ui_stop=0&ui_inspector=0&ui_watermark_link=0&ui_watermark=0&ui_ar=0&ui_help=0&ui_settings=0&ui_vr=0&ui_fullscreen=0&ui_annotations=0&scrollwheel=0&orbit_constraint_zoom_out=40",
  //   "https://sketchfab.com/models/2f7f01342d6f4a5f9338e8cd199b31f3/embed?autospin=0.1&autostart=1&camera=0&transparent=1&ui_animations=0&ui_infos=0&ui_stop=0&ui_inspector=0&ui_watermark_link=0&ui_watermark=0&ui_ar=0&ui_help=0&ui_settings=0&ui_vr=0&ui_fullscreen=0&ui_annotations=0&scrollwheel=0&orbit_constraint_zoom_out=1950",
  //   "https://sketchfab.com/models/ec2211d2f4694f2897148ae720cd3af6/embed?autospin=0.1&autostart=1&camera=0&transparent=1&ui_animations=0&ui_infos=0&ui_stop=0&ui_inspector=0&ui_watermark_link=0&ui_watermark=0&ui_ar=0&ui_help=0&ui_settings=0&ui_vr=0&ui_fullscreen=0&ui_annotations=0&scrollwheel=0&orbit_constraint_zoom_in=350",
  //   "https://sketchfab.com/models/0a580c671f534aa9847c403e33d322f3/embed?autospin=0.1&autostart=1&camera=0&transparent=1&ui_animations=0&ui_infos=0&ui_stop=0&ui_inspector=0&ui_watermark_link=0&ui_watermark=0&ui_ar=0&ui_help=0&ui_settings=0&ui_vr=0&ui_fullscreen=0&ui_annotations=0&scrollwheel=0&orbit_constraint_zoom_out=150"
  // ]

  const srcIframeArray = [
    "086cb5d3ce504f11a085a3d5acb6c00b",
    "2f7f01342d6f4a5f9338e8cd199b31f3",
    "ec2211d2f4694f2897148ae720cd3af6"
  ]
  const controlScroll = (e) => {
    
    if(numbers.current !== null) {
      const elBox = numbers.current.getBoundingClientRect().top

      if(elBox <= 0 && !autoOpen) {
        autoOpen = true
        openOverlay();
      }
    }
    
  }

  const columnsEntries = [
    {
      title: '66% more engagement',
      text: 'Adding 3D models to your current e-commerce experience has been proven to drastically improve customer engagement. (Khronos)'
    },
    {
      title: '10x more time on site, +40% conversions',
      text: 'interactive 3D digital twins and product configurators can significantly increase customer interaction and satisfaction. Your website visitors will be more likely to spend time on your page (sketchfab) and more prone to purchasing an item (Khronos)'
    },
    {
      title: 'Higher quality,<br/>-35% return rate',
      text: 'Showcase your full product range, down to every detail. Make sure you show your customers exactly what you have to offer by allowing them to fully inspect your products. A correctly informed customer is more likely to buy an item, less likely to return it.'
    }
  ];

  const columnsEntriesBottom = [
    {
      title: 'True-to-life',
      text: 'Engage your customers and increase conversions through mind blowing visuals and never before seen realism, down to every detail, it doesn’t matter if it is a printed text on your packaging, or the smallest detail of a product.'
    },
    {
      title: 'Standard',
      text: 'Optimize costs and save time. Whether you need to digitize one, ten or a thousand products, we have the right solution.'
    },
    {
      title: 'Scalable',
      text: 'Make it once, use it anywhere. Our standard 3D Models are the best solution to fit in any digital context: from e-commerce to digital marketing, AR, VR, Web3 and Metaverse experiences'
    }
  ]
  const checkMobile = () => {
    setIsMobile(window.innerWidth < 1024)
  }
  useEffect(() => {

    document.title = "3D Commerce by Invrsion";
    
    window.addEventListener('resize', (e) => { checkMobile() });
    checkMobile()

    fetch(`${BaseUrl}/page?key=invrsion&slug=3d-commerce-landing`, {
      method: 'GET'
    })
    .then(response => {
      return response.json()
      
    }).then((res) => {
      
      setArrayImgsCarousel(res.data.sliderSketchfab);
      arrayLoad = [
        ...arrayLoad,
        ...arrayImgsCarousel
      ]
      
      setIsFetching(false);
      
    })

    return () => {
      window.removeEventListener('resize', checkMobile())
    }
  }, [])
  
  return (
    <React.Fragment>
      {
        arrayImgsCarousel.length > 0 &&
        <Hero3dCommerce 
          idScroll="3dCommerce"
          title="Maximize your<br/>e-commerce performance" 
          img={imgHero}>
        </Hero3dCommerce>
      }

      <HomeColumns entries={columnsEntries} separators={false} />

      {
        (arrayImgsCarousel.length > 0 && !isMobile) &&
        <ProdsCarousel imgs={arrayImgsCarousel} withIframe={true} srcIframeArray={srcIframeArray}></ProdsCarousel>

      }

      {
        (arrayImgsCarousel.length > 0 && isMobile) &&
        <ProdsCarousel imgs={arrayImgsCarousel} withIframe={false} ></ProdsCarousel>

      }
      <HomeColumns entries={columnsEntriesBottom} separators={false} />

      <div className="side--quote-wrap side--quote-wrap-tablet no-margin-btm">
        <div className="side--title">
          <p  className="preset-9">
            Transform any product into a realistic, 3D real-time
            rendered Digital Twin. Feature them in your online
            strategy to let your customers experience the
            difference.
          </p>
          <div className="rounded--cta center-cta" onClick={clickLink}>
            <p className="preset-11">Try our 3D ecommerce solution</p>
          </div>
        </div>
        
        <div className="side--text">
            <img className="full" src={require('../../assets/fashion-webstore.png')} />
        </div>
      </div>

      <div className="side--quote-wrap extra--margin" ref={numbers}>
        <div className="side--title">
          <h6 className="md--title">3D models / 3D modeling</h6>
         
        </div>
        <p className="preset-9 side--text">We use our patented and optimized digitization system based on AI and Computer Vision to create 3D digital twins of your
products to add to your online strategy. Made up of ultra-realistic textures, physics and materials, these real-time renders are
multi-channel, customizable and easily embeddable through viewers and configurators.</p>
      </div>
      <div className="side--quote-wrap">
        <h6 className="md--title side--title">Partner with the best</h6>
        <div className="side--text">
          <img className="intro-img" src={require('../../assets/3DCommerce_RGB_Aug20.png')} />
          <img className="intro-img" src={require('../../assets/Khronos_RGB_June18.png')} />
          <p className="preset-9">Thanks to our partnership with Sketchfab we can provide you the most efficient and reliable platform to publish 3D content, ensuring its
            compatibility across every browser, operating system, desktop and mobile</p>
          <br />
          <img className="intro-img" src={require('../../assets/Sketchfab_logo.png')} />
          <br/>
          <p className="preset-9">
            We are part of The Khronos 3D Commerce Working Group, collaborating with the biggest retailers in the world for the creation of a standard to Shape the Future of 3D Content in
          Advertising and Retail
          </p>
        </div>
      </div>

      {
        !loader.isLoading &&
        <VideoScrollAlone
          idScroll="video-3dcommerce"
          video={require('../../assets/video/video-case-3dcommerce.mp4')} 
        />
      }
      <Banner  text="Intrigued? Let’s have a chat." route="/reach-out" copyRoute="Reach out" />
      {/* <div className="rounded--cta cta--fixed cta--blink" onClick={() => openOverlay()}>
        Get more info
      </div> */}
      <FormOverlay 
        title="Intrigued? Keep in touch" 
        paragraph="Subscribe to our 3D Commerce updates to receive invites to upcoming webinars and events, ensuring you don’t miss a thing happening in this fast-paced field."
        isOverlayOpen={isOverlayOpen} closeFn={openOverlay}/>
      <Loader 
        isFetching={true}
        arrayLoad={arrayLoad}
      />
    </React.Fragment>
  );
};

export default Products3dCommerceContainer;
